import type {
  Export,
  QueryExportMemberRequestArgs,
} from '@tribeplatform/gql-client/types'
import type { ExportFields } from '@tribeplatform/gql-client/types/generated'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getExportRequestKey } from '../../utils/keys/export.keys.js'

export const useExportMemberRequest = (options: {
  variables: QueryExportMemberRequestArgs
  fields?: ExportFields
  useQueryOptions?: UseQueryOptions<Export>
}) => {
  const { variables, fields = 'basic', useQueryOptions } = options
  const { client } = useTribeClient()
  const exportRequestKey = getExportRequestKey({ variables, fields })

  return useQuery<Export>(
    exportRequestKey,
    () =>
      client.query({
        name: 'exportMemberRequest',
        args: {
          fields,
          variables,
        },
      }),
    useQueryOptions,
  )
}
